export type Nullable<T> = T | null

export enum AgeType {
  AGE_NOW = 'age_now',
  AGE_DEATH = 'age_death',
  AGE_RETIREMENT = 'age_retirement',
  AGE_SOCIAL_SECURITY = 'age_social_security',
  AGE_REQUIRED_DISTRIBUTIONS = 'age_required_distributions',
  AGE_IN_A_YEAR = 'age_in_a_year',
}

export enum ValuePeriod {
  YEARLY = 'yearly',
  QUARTERLY = 'quarterly',
  MONTHLY = 'monthly',
  BIWEEKLY = 'biweekly',
  WEEKLY = 'weekly',
  DAILY = 'daily',
}

export enum Relation {
  SPOUSE = 'Spouse',
  CHILD = 'Child',
  PARENT = 'Parent',
  SIBLING = 'Sibling',
  DEPENDENT = 'Dependent',
  UNMARRIED_PARTNER = 'Unmarried Partner',
  SOLO = 'Solo',
  GRANDCHILD = 'Grandchild',
  GREAT_CHILD = 'Great-child',
  HEIR = 'Heir',
}
